<app-detail-view-template *ngIf="ProfileData$ | async as profileData; else loadingTemplate">
    <ng-container *appDetailViewButtons>
        <button app-round-button
                *ngIf="!(Editing$ | async)"
                class="header-button"
                (click)="OpenEdit$.next()"
                Inverted
                matTooltip="Bearbeiten"
        >
            <fa-icon icon="pencil-alt"></fa-icon>
        </button>

        <button
            app-round-button
            *ngIf="Editing$ | async"
            class="header-button"
            (click)="CloseEdit()"
            Inverted
            matTooltip="Verwerfen"
        >
            <fa-icon icon="times"></fa-icon>
        </button>

        <button
            app-round-button
            *ngIf="Editing$ | async"
            class="header-button"
            (click)="Save$.next()"
            Inverted
            matTooltip="Speichern"
            [Disabled]="ContractForm.invalid || ContractOptionsForm.invalid"
        >
            <fa-icon icon="save"></fa-icon>
        </button>

        <button
            app-round-button
            class="header-button"
            (click)="OpenDeletedDialog$.next()"
            Inverted
            matTooltip="Löschen"
            Color="red"
        >
            <fa-icon icon="trash"></fa-icon>
        </button>
    </ng-container>

    <ng-container *appDetailViewLeftContent>
        <app-profile-template
            (Submit)="Save$.next()"
            [Data]="profileData"
            [Editing]="Editing$ | async">
        </app-profile-template>
<!--        ToDo: FileCardList einbauen-->
        <app-file-explorer
            *ngIf=" true || (ViewStyle$ | async) === FileViewStyles.List || (ViewStyle$ | async) === FileViewStyles.Tile"
            [SelectedFolderId]="FolderId$ | async"
            [FileUploadButton]="true"
            (FileUploadClicked)="PreviewedFileId$.next(null)"
            (FileClicked)="PreviewedFileId$.next($event);"
            class="detail-card mat-card"
            style="height: 40rem; padding: 0; margin-top: 1rem">
        </app-file-explorer>
    </ng-container>

    <ng-container *appDetailViewRightContent>
        <mat-card class="card card-container right" *ngIf="!(Editing$ | async)">
            <div class="card-header">
                <fa-icon class="icon" icon="building"></fa-icon>

                <h3>Kunden</h3>

                <button
                    app-round-button
                    matTooltip="Auswählen"
                    matTooltipPosition="left"
                    (click)="OpenCustomerSelect$.next()"
                >
                    <fa-icon icon="user-cog"></fa-icon>

                </button>
            </div>
            <!-- CSS-Klasse ist nur für den inset box shadow -->
            <ngx-simplebar class="clickable-list-container">

                <table mat-table [dataSource]="FilteredCustomers">
                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let rowData">
                            <fa-icon mat-list-avatar icon="building" size="2x"></fa-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="customerNo">
                        <td mat-cell *matCellDef="let rowData">
                        <td mat-cell *matCellDef="let rowData">
                            {{ rowData.CustomerNo }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let rowData">
                            {{ rowData.Name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="duration">
                        <th mat-header-cell *matHeaderCellDef>Teilnahme<br>zeitraum</th>
                        <td mat-cell *matCellDef="let rowData">
                            {{ rowData.Duration }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ausnahmedatum">
                        <th mat-header-cell *matHeaderCellDef>Ausnahme<br>datum</th>
                        <td mat-cell *matCellDef="let rowData">
                            {{ rowData.AusnahmeDatum }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="['image', 'name', 'duration', 'ausnahmedatum']"></tr>
                    <tr
                        mat-row
                        *matRowDef="let rowData; columns: ['image', 'name', 'duration', 'ausnahmedatum']"
                        [routerLink]="['/', CustomerAdministrationMeta.Path, rowData.Id]"
                        routerLinkActive="active"
                    >
                    </tr>
                </table>
                <table
                    *ngIf="!((FilteredCustomers)?.length > 0)"
                    style="width: 100%"
                >
                    <tr>
                        <td class="empty-table-text">
                            Keine zugeordneten Kunden gefunden
                        </td>
                    </tr>
                </table>
            </ngx-simplebar>
        </mat-card>
    </ng-container>
</app-detail-view-template>

<ng-template #loadingTemplate>
    <app-loading></app-loading>
</ng-template>

<app-detail-filter
    [(FilterOpen)]="FilterOpen"
    [CustomersInput]="SearchedCustomerList$ | async"
    (FilteredCustomersOutput)="FilteredCustomers = $event"
>
</app-detail-filter>

<mat-card *ngIf="PreviewedFileId$ | async" class="new-document-overlay">
    <ng-container *ngIf="PreviewedFileId$ | async as id">
        <button app-round-button class="back-button" (click)="PreviewedFileId$.next(null)">
            <fa-icon icon="chevron-right"></fa-icon>
        </button>
        <app-preview [FileId$]="PreviewedFileId$"
                     (ClosePreview)="PreviewedFileId$.next(null)">
        </app-preview>
    </ng-container>
</mat-card>
